import * as ActionTypes from './types.action';

export const getUpsellingItems = (itemIds, filter) => ({
  type: ActionTypes.GET_UPSELLING_ITEMS_REQUESTED,
  itemIds,
  filter,
});
